import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeRecordDebitsWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.record.debits",
  name: "Posted debits",
  description: "Posted debits for the selected dashboard period.",
  apps: [
    "finance",
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.posted-journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "debit",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Posted debits",
    subtext: "",
    icon: "money",
    color: "primary",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "0",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
